(function () {
  function initAppointmentModal() {
    document.querySelectorAll('[data-appointment-modal-open]').forEach((trigger) => {
      if (trigger.dataset.appointmentBound === 'true') return;
      trigger.dataset.appointmentBound = 'true';

      trigger.addEventListener('click', (event) => {
        const modalId = trigger.getAttribute('aria-controls');
        const modal = modalId
          ? document.getElementById(modalId)
          : document.querySelector('[data-appointment-modal]');

        if (modal && typeof modal.showModal === 'function') {
          event.preventDefault();
          modal.showModal();
        }
      });
    });

    document.querySelectorAll('[data-appointment-modal]').forEach((modal) => {
      if (modal.dataset.appointmentBound === 'true') return;
      modal.dataset.appointmentBound = 'true';

      modal.querySelectorAll('[data-appointment-modal-close]').forEach((closeBtn) => {
        closeBtn.addEventListener('click', () => {
          if (modal.open) modal.close();
        });
      });

      modal.addEventListener('click', (event) => {
        const panel = modal.querySelector('.header-appointment-modal__panel');
        if (panel && !panel.contains(event.target)) {
          modal.close();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppointmentModal);
  } else {
    initAppointmentModal();
  }

  document.addEventListener('shopify:section:load', initAppointmentModal);
})();
